import { runtimeEnv } from '@/config/featureFlags';

const STORAGE_PREFIX = 'billing_notice';
const REMINDER_SCOPE = 'creditReminder';
// 决策结论：3 天一次，终身不限
export const REMINDER_COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000;

const isBrowserStorageAvailable = () => {
    try {
        return typeof window !== 'undefined' && !!window.localStorage;
    } catch {
        return false;
    }
};

// 决策结论：按 beta/prod 隔离，与后端 billing namespace（beta_sandbox_v1 / production_live_v1）对齐
const resolveEnvSegment = () => (runtimeEnv.isProduction ? 'prod' : 'beta');

const normalizeUserId = (userId) =>
    typeof userId === 'string' && userId.trim() ? userId.trim() : '';

export const buildReminderKey = (userId) => {
    const uid = normalizeUserId(userId);
    if (!uid) return null;
    return `${STORAGE_PREFIX}:${resolveEnvSegment()}:${uid}:${REMINDER_SCOPE}`;
};

const emptyState = () => ({ lastShownAt: null, showCount: 0 });

export const getReminderState = (userId) => {
    if (!isBrowserStorageAvailable()) return emptyState();
    const key = buildReminderKey(userId);
    if (!key) return emptyState();
    try {
        const raw = window.localStorage.getItem(key);
        if (!raw) return emptyState();
        const parsed = JSON.parse(raw);
        const lastShownAt = Number(parsed?.lastShownAt);
        const showCount = Number(parsed?.showCount);
        return {
            lastShownAt: Number.isFinite(lastShownAt) ? lastShownAt : null,
            showCount: Number.isFinite(showCount) ? showCount : 0
        };
    } catch {
        // JSON 损坏降级为"从未展示"
        return emptyState();
    }
};

export const isReminderInCooldown = (userId) => {
    const { lastShownAt } = getReminderState(userId);
    if (!lastShownAt) return false;
    return Date.now() - lastShownAt < REMINDER_COOLDOWN_MS;
};

// 展示提醒后写入；首次弹窗展示后也调此函数种入冷却
export const markReminderShown = (userId, shownAt = Date.now()) => {
    if (!isBrowserStorageAvailable()) return false;
    const key = buildReminderKey(userId);
    if (!key) return false;
    const prev = getReminderState(userId);
    try {
        window.localStorage.setItem(
            key,
            JSON.stringify({ lastShownAt: shownAt, showCount: prev.showCount + 1 })
        );
        return true;
    } catch {
        return false;
    }
};

// 别名：首次弹窗种入冷却（语义同 markReminderShown，但不递增 showCount，因为不是一次"提醒展示"）
export const seedReminderCooldown = (userId, shownAt = Date.now()) => {
    if (!isBrowserStorageAvailable()) return false;
    const key = buildReminderKey(userId);
    if (!key) return false;
    const prev = getReminderState(userId);
    try {
        window.localStorage.setItem(
            key,
            // 种入不递增 showCount（不是提醒展示），仅记录冷却起点
            JSON.stringify({ lastShownAt: shownAt, showCount: prev.showCount })
        );
        return true;
    } catch {
        return false;
    }
};

// 登出清理（可选）：仅清会话级内存，不删 localStorage（同用户再登录应尊重冷却）。
// 频控持久化在 manager 模块内，这里提供空占位供 manager 调用以保持职责清晰。
export const clearInMemoryReminderGuard = () => { /* 占位，供 manager 调用 */ };
